<template>
    <div>
        <TopbarSaleEs titolo="SALA IX"/> 

        <div class="imgAntSala">
            <img src="@/assets/sale/9-Sala_IX.jpg" alt="Sala IX">
        </div>

        <div class="contenutoSala">           
            <h3 class="titoloContenutoSala">SALA IX <br> TopbarSaleEs</h3>
            <audio controls class="audio">
                <source src="@/assets/audio/sala_nove.mp3" type="audio/mpeg">
            </audio> 
            <p class="traccia"><i>Escuchar la pista de audio</i></p>
            <p class="desContenutoSala">
                En el pequeño medallero hay una pequeña colección de monedas romanas de época republicana e imperial que pueden
             observarse en ambos lados. 
            </p>

            <div class="image-container">
                <img src="@/assets/sale/9-Sala_IX.jpg" alt="Sala IX">
            </div>            
        </div>

        
        
                
    </div>
</template>

<script>
    import TopbarSaleEs from '@/components/TopbarSaleEs.vue';

    export default {
        name: 'Sala9Es',
        components: {
            TopbarSaleEs
        }
    }
</script>